import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { database } from './App';
import Overlay from './Overlay';
import reportWebVitals from './reportWebVitals';

// Opened inside Discord as an Activity (Discord adds frame_id): just the game. Each game is its own Discord app, served
// at <app id>.discordsays.com, so the address says which one. Loaded only then, so the site doesn't carry Discord's SDK
const CHEEKY_DASH_APP = '1567242756991098900';
const CheekyDashActivity = React.lazy(() => import('./CheekyDashActivity'));
const BattleArenaActivity = React.lazy(() => import('./BattleArenaActivity'));
const inDiscord = new URLSearchParams(window.location.search).has('frame_id');
const Activity = window.location.hostname.split('.')[0] === CHEEKY_DASH_APP ? CheekyDashActivity : BattleArenaActivity;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* /overlay is the see-through page for OBS: none of the site around it */}
    {inDiscord ? <React.Suspense fallback={null}><Activity /></React.Suspense>
      : window.location.pathname.replace(/\/$/, '') === '/overlay' ? <Overlay database={database} /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
